import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiFetch } from '../services/api';
import { auth, onAuthStateChanged, signOut } from '../services/firebase';
import { api } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          const me = await apiFetch('/api/users/me');
          // Merge isSuperAdmin onto the Firebase user object
          firebaseUser.isSuperAdmin = me.is_super_admin === true;
        } catch {
          firebaseUser.isSuperAdmin = false;
        }
      }
      setUser(firebaseUser);
      setLoading(false);
    });
    return unsub;
  }, []);

  const getToken = () => auth.currentUser?.getIdToken() ?? null;

  useEffect(() => {
    window.__rajiGetToken = getToken;
  }, []);

  const logout = async () => {
    await signOut(auth);
  };

  const registerBackend = async (firebaseUser) => {
    try {
      await api.registerUser({
        firebase_uid: firebaseUser.uid,
        email:        firebaseUser.email,
        name:         firebaseUser.displayName || '',
      });
    } catch (e) {
      console.warn('Backend registration error:', e);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout, registerBackend, getToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);